import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetch = (get: any) => ({
    type: 'fetch_GET_success',
    payload: get,
});
export const fetchRegion = (region: any) => ({
    type: 'fetch_Region_success',
    payload: region,
});export const fetchCountry = (country: any) => ({
    type: 'fetch_Country_success',
    payload: country,
});

export const getSpecialityData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1};
            const apiname = Admin_API.officer_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetch(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchRegionsData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:'1'};
            const apiname = Admin_API.region_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchRegion(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchCountryData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {};
            const apiname = SUPRIVISOR_API.getcountry;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchCountry(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
